define('appkit/singleton.registry',[
  'underscore',
  'backbone',
  'backbone.radio'
], function(
  _,
  Backbone,
  Radio
) {

  var Singleton = {

      channelName: 'singleton',

      eventBuses: [],

      channel: function() {
        return Radio.channel(Singleton.channelName);
      },

      addEventBus: function(bus) {
        this.eventBuses.push(bus);
        return this;
      },

      get: function(name) {
        return Singleton.channel().request(name);
      },

      getAsync: function(name, fn, context) {
        if (Singleton.has(name)) {
          fn.call(context || this, Singleton.get(name));
        } else {
          Singleton.channel().once('register:' + name, function() {
            fn.call(context || this, Singleton.get(name));
          }, this);
        }
        return this;
      },

      has: function(name) {
        var requests = Singleton.channel()._requests;
        return !!(requests && requests[name]);
      },

      register: function(name, instance) {
        var channel = Singleton.channel();
        channel.reply(name, instance);
        channel.trigger('register:' + name, instance);
        _.each(this.eventBuses, function(bus) {
          bus.trigger('register:' + name, instance);
        });
        return this;
      }

  };

  return Singleton
})
;
